import { Component, OnInit, HostListener } from '@angular/core';
import { ApiService } from "../../api.service";
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { CommonService } from "../../shared/common.service";
import { Study, Template, Site } from '../../study.model';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ValidationErrors } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

declare var bootstrap: any;
@Component({
  selector: 'app-study-list',
  templateUrl: './study-list.component.html',
  styleUrls: ['./study-list.component.scss']
})
export class StudyListComponent implements OnInit {
  dtOptions: { pagingType: string; pageLength: number; processing: boolean; ajax: (dataTablesParameters: any, callback: any) => void; columns: { title: string; data: string; }[]; };
  studyName: string;
  studyCode: string;
  cdaDocumentLink:string;
  studyDuration: number;
  noOfDays: number;
  buffer: number;
  validationMessage: string = '';
  validationMessage1: string = '';
  validationMessage2: string = '';
  validationMessage3: string = '';
  validationMessage4: string = '';
  validationMessage5: string = '';
  validationMessage6: string = '';
  validationMessage7: string = '';
  volunteerFrequencyValidationMessage: string = '';
  bufferValidationMessage: string = '';
  isEditMode: boolean = false;
  showCreateStudyModal: boolean = false;
  user_id: string;

  bufferDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  dropdownSettings = {};
  templateDropdownSettings  = {};
  siteDropdownSettings  = {};

  list: []= [];

  studyForm: FormGroup;
  generatedDayInputs: number[] = [];


  searchName: string = '';

  filterById: any  =  '';

  filterByCenter : string = '';

  assignedBy: string = '';
  status: string = '';
  statusFilter: string = '';
  data: any[] = [];
  filteredData: any[] = [];
  paginatedData: any[] = [];
  editStudyData: any;

  // currentPage = 0;
  // pageSize = 10; // Number of items per page
  totalPages: number[] = [];
  userId: any;
  id: any
  users = [];

  
  currentPage = 1; 
  pageSize = 10;  
  pages = 0; 
  totalUsers = 0; 
  Data: any;


  // currentPage: number = 1;
  recordsPerPage: number = 10;
  pageRange: number[] = [];
  // pageRange: number[] = []; 
  previousPage: number;
  
  maxPagesToShow: number = 4; 

  buffers: number[] = []
  // siteLocations: any[];
  templateId: string;
  templatesList: { item_id: string; item_text: string }[] = [];
  siteLocations: { item_id: string | number; item_text: string }[] = [];

  // Custom dropdown properties for site location
  showSiteLocationDropdown: boolean = false;
  siteLocationSearchTerm: string = '';
  filteredSiteLocations: { item_id: string | number; item_text: string }[] = [];

  error: string;
  studies: any;
  groupedStudies: any[];
  currentPageData: any[];



  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService
  ) {
    this.studyForm = this.fb.group({
      studyName: ['', Validators.required],
      studyCode: ['', Validators.required],
      // cdaDocumentLink: ['', Validators.required],
      // studyDuration: ['', Validators.required],
      // buffer: ['', Validators.required],
      //selectedCrcs: [[], Validators.required],
    selectedTemplate: [null, Validators.required],
    selectedSiteLocations: [[], Validators.required]
      // noOfDays: ['', Validators.required],
      // volunteerFrequencies: this.fb.array([]),

      // buffer : this.fb.array([]),

      // volunteerFrequencySum: ['', [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit(): void {
    // let userData = this.commonService.getUserData();

    // this.Data = userData;

    // console.log('data checking here')
    // if (userData == null || userData.designation != 'CRO') {
    //   this.commonService.navigateTo("/");
    // }

    // const params = new HttpParams().set('userId', userData.id);
    // this.apiService.get<Study[]>('api/getAllStudies', params).subscribe({
    //   next: (response: any[]) => {
    //     this.data = response;
    //     this.applyFilters();
    //     //this.filteredData = this.data;
    //   },
    //   error: (error) => {
    //     console.error('Error fetching site activities:', error);
    //     // Handle the error: show a message, redirect, etc.
    //   }
    // });


    // this.loadUsers(this.currentPage);

    let userData = this.commonService.getUserData();
    this.user_id = userData.id;
    this.Data = userData;

    if (userData == null || userData.designation != 'CRO') {
      //this.commonService.navigateTo("/");
    }


    let params = new HttpParams();
    params = params.set('userId', userData.id);
    params = params.set('designation', userData.designation);

    this.loadUsers(this.currentPage);


      
// Fetch locked templates
this.apiService.getLockedTemplates(this.user_id).subscribe({
  next: (response: Template[]) => {
    console.log('Templates List:', response);
    this.templatesList = response.map(template => ({
      item_id: template.id,
      item_text: template.name
    }));
  },
  error: (err) => {
    console.error('Error fetching locked templates:', err);
    this.templatesList = [];
  }
});

// Fetch sites
this.apiService.getSites(this.user_id).subscribe({
  next: (response: Site[]) => {
    this.siteLocations = response.map(site => ({
      item_id: site.site_id,  // Use site_id (6-digit alphanumeric) instead of id (sequential)
      item_text: site.site_name
    }));
    this.filteredSiteLocations = [...this.siteLocations];
  },
  error: (err) => {
    console.error('Error fetching sites:', err);
    this.siteLocations = [];
    this.filteredSiteLocations = [];
  }
});


    /*this.dropdownSettings = {
      singleSelection: false, // Set to true if you want only one item to be selected
      idField: 'item_id', // Key for unique identification
      textField: 'item_text', // Key for display text
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true, // Enable search functionality
    };*/
    this.dropdownSettings = {
      singleSelection: false, // Allow multiple selections
      idField: 'item_id', // Key for unique identification
      textField: 'item_text', // Key for display text
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3, // Show up to 3 selected items
      allowSearchFilter: true, // Enable search functionality
    };
    
    this.templateDropdownSettings = { ...this.dropdownSettings, singleSelection: true };
this.siteDropdownSettings = { ...this.dropdownSettings, singleSelection: true };



    // Retrieve the token from cookies when the component initializes
    this.userId = this.cookieService.get('userData');
    // Parse the string into an object


    const jsondata = JSON.parse(this.userId);

    this.id = jsondata.id

  


  }


  get buffe(): FormArray {
    return this.studyForm.get('buffer') as FormArray;
  }
   
 
  // private loadSiteLocations(): void {
  //   this.apiService.getSiteLocations().subscribe(response => {
  //     this.siteLocations = response.map((item: any) => item.site_locations);
     

  //   });

  //   console.log('locations here', this.siteLocations)


  // }


  deleteStudy(id: number) { 

    if (confirm('Are you sure you want to delete this study? This action cannot be undone.')){
      this.apiService.deleteStudy(id).subscribe(
        (res) => {
          window.alert('Study deleted successfully!');
         

          window.location.reload();

  
        },
        (err) => {
          window.alert('Some Error Occurred');
          console.error(err);
        }
      );
    }
  }
  




  searchUsers(): void {

    const userId = this.Data.id;

    this.apiService.getAllStudies(userId, this.currentPage, this.pageSize, this.searchName, this.assignedBy, this.statusFilter, this.status).subscribe(
      (response: any) => {
        this.users = response.data;
        this.pages = response.totalPages;
        this.totalUsers = response.totalStudies;
        //this.currentPageData = this.users;
  
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }
  
  

  /*loadUsers(page: number): void {
    const userId = this.Data.id;
  
    this.apiService.getAllStudies(
      userId, 
      this.currentPage, 
      this.pageSize, 
      this.searchName, 
      this.assignedBy, 
      this.status,       // Keep this for status filter
      this.statusFilter  // This is for is_active filter
    ).subscribe(
      (response: any) => {
        this.users = response.data;
        this.data = response.data;
  
        // Process user data
        this.users = this.data.map(user => ({
          ...user,
          name: user.study_name,
        }));
  
        this.pages = response.totalPages;
        this.totalUsers = response.totalUsers;
  
         // Update the page range for pagination display
         this.updatePageRange();
  
      },
      error => {
        console.error('Error fetching users', error);
      }
    );
  }*/
 loading: boolean = false;

    loadUsers(page: number): void {
      this.loading = true;
      const userId = this.Data.id;
    
      this.apiService.getAllStudies(
        userId, 
        this.currentPage, 
        this.pageSize, 
        this.searchName, 
        this.assignedBy, 
        this.status, 
        this.statusFilter
      ).subscribe(
        (response: any) => {
          this.users = response.data;
          this.pages = response.totalPages;
          this.totalUsers = response.totalStudies;
          this.loading = false; // ✅ Stop loading
        },
        error => {
          console.error('Error fetching users', error);
          this.loading = false; // ❌ Stop loading even if failed
        }
      );
    }
  


// Update the visible page range based on the current page
updatePageRange(): void {
  this.pageRange = []; // Clear the existing page range

  const startPage = Math.floor((this.currentPage - 1) / this.maxPagesToShow) * this.maxPagesToShow + 1;
  const endPage = Math.min(startPage + this.maxPagesToShow - 1, this.pages);

  for (let i = startPage; i <= endPage; i++) {
    this.pageRange.push(i);
  }
}

nextPage(): void {
  if (this.currentPage < this.pages && this.users.length >= this.pageSize) {
    this.currentPage++;
    this.updatePageRange();
    this.loadUsers(this.currentPage); // Fetch users for the next page
  }
}

prevPage(): void {
  if (this.currentPage > 1) {
    this.currentPage--;
    this.updatePageRange();
    this.loadUsers(this.currentPage); 
  }
}
shouldDisableNext(): boolean {
  // Disable if on last page OR if current page data is less than page size
  return this.currentPage >= this.pages || this.users.length < this.pageSize;
}

// Check if Previous button should be disabled
shouldDisablePrevious(): boolean {
  return this.currentPage <= 1;
}

goToPage(pageIndex: number): void {
  if (pageIndex > 0 && pageIndex <= this.pages) {
    this.currentPage = pageIndex;
    this.updatePageRange();
    this.loadUsers(this.currentPage); 
  }
}

applyFilters(): void {


  this.filteredData = this.data.filter(item => {
    const matchesStudyName = this.searchName === '' || (item.study_name?.toLowerCase() ?? '').includes(this.searchName.toLowerCase());
    const matchesAssignedBy = this.assignedBy === '' || (item.assigned_by?.toLowerCase() ?? '').includes(this.assignedBy.toLowerCase());
    const matchesStatus = this.status === '' || (item.study_status?.toLowerCase() ?? '').includes(this.status.toLowerCase());
    const matchesStatusFilter = this.statusFilter === '' ||
      (this.statusFilter === '1' ? item.is_active === 1 : this.statusFilter === '0' ? item.is_active === 0 : true);

    return matchesStudyName && matchesAssignedBy && matchesStatus && matchesStatusFilter;
  });

  this.calculateTotalPages();
  if (this.currentPage >= this.totalPages.length) {
    this.currentPage = this.totalPages.length - 1;
  }
  this.updatePaginatedData();


}
calculateTotalPages(): void {
  const pageCount = Math.ceil(this.filteredData.length / this.pageSize);
  this.totalPages = Array.from({ length: pageCount }, (_, i) => i);
}

updatePaginatedData(): void {
  const start = this.currentPage * this.pageSize;
  const end = start + this.pageSize;
  this.paginatedData = this.filteredData.slice(start, end);
}
clear(){
  this.searchName = '';
  this.assignedBy = '';
  this.status = '';
  this.statusFilter = '';
  this.currentPage = 1;   // Reset to first page
  this.loadUsers(this.currentPage);

}

/*
openEditModal(studyData: any = {}): void {
  console.log('StudyForm Data Here', studyData);

  this.isEditMode = !!studyData.study_name; 
   this.editStudyData = studyData;

  if (this.isEditMode) {
     this.editStudy(studyData);

    const bufferControl = this.studyForm.get('buffer') as FormArray;
    if (studyData.buffer && studyData.buffer.length > 0) {
      // Update existing buffer controls or create new ones
      studyData.buffer.forEach((bufferItem: any, index) => {
        const control = bufferControl.at(index) as FormControl;
        if (control) {
          control.setValue(bufferItem.Buffers);
        } else {
          bufferControl.push(this.fb.control(bufferItem.Buffers, this.validateBufferValue));
        }
      });
    } else {
      bufferControl.clear(); 
    }

    bufferControl.controls.forEach(control => control.disable());
  } else {

    this.isEditMode = false; 
     this.editStudyData = {};

    this.studyForm.enable();
    this.generatedDayInputs = [];
    this.studyForm.patchValue({
      volunteerFrequencies: []
    });
  }
 
  const modalElement = document.getElementById('createStudyModal');
  if (modalElement) {
    const bootstrapModal = new bootstrap.Modal(modalElement);
    bootstrapModal.show();
  }
}

*/
// Open create study modal
openCreateStudyModal(): void {
  this.isEditMode = false;
  this.editStudyData = {};
  this.studyForm.reset();
  
  // Ensure all fields are enabled when creating new study
  this.studyForm.get('selectedTemplate')?.enable();
  this.studyForm.get('studyName')?.enable();
  this.studyForm.get('studyCode')?.enable();
  
  this.showCreateStudyModal = true;
}

// Close create study modal
closeCreateStudyModal(): void {
  this.showCreateStudyModal = false;
  this.editStudyData = {};
  this.studyForm.reset();
  
  // Ensure all fields are enabled when closing modal
  this.studyForm.get('selectedTemplate')?.enable();
  this.studyForm.get('studyName')?.enable();
  this.studyForm.get('studyCode')?.enable();
}

// for fetching the selected / linked template and site while editing
openEditModal(studyData: any = {}): void {
  this.isEditMode = !!studyData.study_name;
  this.editStudyData = studyData;

  if (this.isEditMode) {
    // Find the matching template and site from the dropdown lists
    // Use new direct fields first, fallback to old array structure
    let currentTemplate: { item_id: string; item_text: string } | null = null;
    if (studyData.template_name) {
      // Use new direct field - find by template name
      currentTemplate = this.templatesList.find(t => t.item_text === studyData.template_name) || null;
    } else if (studyData.template_list && studyData.template_list.length > 0) {
      // Fallback to old array structure - find by template name (same as getTemplateName method)
      const templateName = studyData.template_list[0].name;
      if (templateName) {
        currentTemplate = this.templatesList.find(t => t.item_text === templateName) || null;
      }
    }
    
  
    let currentSite: { item_id: string | number; item_text: string } | null = null;
    
    // Check if sites are loaded
    if (this.siteLocations && this.siteLocations.length > 0) {
      if (studyData.site_name) {
        currentSite = this.siteLocations.find(s => s.item_text === studyData.site_name) || null;
      } else if (studyData.site_list && studyData.site_list.length > 0) {
        const siteItem = studyData.site_list[0];
        // Try to find by site name if available
        if (siteItem.site_name) {
          currentSite = this.siteLocations.find(s => s.item_text === siteItem.site_name) || null;
        } else {
          // Try to find by site ID as fallback
          const siteId = siteItem.site_id || siteItem.id;
          if (siteId) {
            currentSite = this.siteLocations.find(site => site.item_id == siteId) || null;
          } else {
            currentSite = null;
          }
        }
      }

    } else {
      // If sites are not loaded, fetch them now
      this.apiService.getSites(this.user_id).subscribe({
        next: (response: Site[]) => {
          this.siteLocations = response.map(site => ({
            item_id: site.site_id,
            item_text: site.site_name
          }));
          
          // Now try to find the current site using new direct field
          let foundSite: { item_id: string | number; item_text: string } | null = null;
          if (studyData.site_name) {
            foundSite = this.siteLocations.find(site => site.item_text === studyData.site_name) || null;

          } else if (studyData.site_list && studyData.site_list.length > 0) {
            const siteItem = studyData.site_list[0];
            // Try to find by site name if available
            if (siteItem.site_name) {
              foundSite = this.siteLocations.find(site => site.item_text === siteItem.site_name) || null;

            } else {
              // Try to find by site ID as fallback
              const siteId = siteItem.site_id || siteItem.id;
              if (siteId) {
                foundSite = this.siteLocations.find(site => site.item_id == siteId) || null;
              } else {
                foundSite = null;
              }
            }
          }
          
          if (foundSite) {
            // Update the form with the found site
            this.studyForm.patchValue({
              selectedSiteLocations: [foundSite]
            });
          }
          
          // Also populate all sites from the study data
          this.populateSitesInForm(studyData);
        },
        error: (err) => {
          console.error('Error fetching sites in edit modal:', err);
        }
      });
    }
    
    // If sites are already loaded, populate them now
    if (this.siteLocations.length > 0) {
      this.populateSitesInForm(studyData);
    }
    
    // Get the sites that were populated by populateSitesInForm
    const populatedSites = this.studyForm.get('selectedSiteLocations')?.value || [];
    
    this.studyForm.patchValue({
      studyName: studyData.study_name,
      studyCode: studyData.code,
      selectedTemplate: currentTemplate || null,
      selectedSiteLocations: populatedSites.length > 0 ? populatedSites : (currentSite ? [currentSite] : [])
    });
    
    // Disable the top three fields when in edit mode
    this.studyForm.get('selectedTemplate')?.disable();
    this.studyForm.get('studyName')?.disable();
    this.studyForm.get('studyCode')?.disable();
  } else {
    this.studyForm.reset();
    // Enable all fields when creating new study
    this.studyForm.get('selectedTemplate')?.enable();
    this.studyForm.get('studyName')?.enable();
    this.studyForm.get('studyCode')?.enable();
  }

  this.showCreateStudyModal = true;
}
  // goToPage(pageIndex: number): void {
  //   this.currentPage = pageIndex;
  //   this.updatePaginatedData();
  // }

  // prevPage(): void {
  //   if (this.currentPage > 0) {
  //     this.currentPage--;
  //     this.updatePaginatedData();
  //   }
  // }

  // nextPage(): void {
  //   if (this.currentPage < this.totalPages.length - 1) {
  //     this.currentPage++;
  //     this.updatePaginatedData();
  //   }
  // }

 


// fetchStudies(): void {

//   this.apiService.getStudies().subscribe(
//     (response) => {
//       const data = response.data; 
//       this.groupedStudies = response.data;

//       console.log('total data here', data)
//       console.log('data checking here', this.groupedStudies);
//     },
//     (err) => {
//       this.error = 'Failed to load studies';
//     }
//   );
// }












groupStudiesByNameAndId(data: any[]): any[] {
  const grouped = data.reduce((acc, current) => {
    const key = `${current.studyId}-${current.name}`; // Unique key for grouping by studyId and name
    if (!acc[key]) {
      acc[key] = {
        studyId: current.studyId,
        name: current.name,
        study_centers: [],
      };
    }
    acc[key].study_centers.push(current.study_centers);
    return acc;
  }, {});

  // Convert object to an array and join study_centers with commas
  return Object.values(grouped).map((item: any) => ({
    studyId: item.studyId,
    name: item.name,
    study_centers: item.study_centers.join(', '),
  }));
}












  // my code starts hereeeeeeeee


  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const enteredDays = parseInt(input.value, 10) || 0;

    if (enteredDays > this.getMaxDays()) {
      this.validationMessage = `Number of days should not exceed ${this.getMaxDays()} days based on the study duration of ${this.studyForm.get('studyDuration')?.value} month(s).`;
      this.studyForm.get('noOfDays')?.setValue(this.getMaxDays());
    } else {
      this.validationMessage = '';
      this.studyForm.get('noOfDays')?.setValue(enteredDays);
    }

    this.generatedDayInputs = Array.from({ length: enteredDays }, (_, i) => i + 1);
    
    this.buffers = this.generatedDayInputs;

    const volunteerFrequenciesControl = this.studyForm.get('volunteerFrequencies') as FormArray;


    const bufferControl = this.studyForm.get('buffer') as FormArray;

    volunteerFrequenciesControl.clear();
    for (let i = 0; i < enteredDays; i++) {
      volunteerFrequenciesControl.push(new FormControl('', Validators.required));


      bufferControl.push(new FormControl('', Validators.required)); // Buffer schedule inputs

    }
    this.checkVolunteerFrequencySum();
  }

  getMaxDays(): number {
    const duration = this.studyForm.get('studyDuration')?.value;
    return duration ? duration * 31 : 0;
  }

  checkVolunteerFrequencies(): boolean {
    const volunteerFrequenciesControl = this.studyForm.get('volunteerFrequencies') as FormArray;
    if (volunteerFrequenciesControl) {
      // Check if all controls have values
      const allFilled = volunteerFrequenciesControl.controls.every(control =>  (typeof control.value == 'string' && control.value.trim() !== '') || (typeof control.value != 'string'));
      if (!allFilled) {
        this.volunteerFrequencyValidationMessage = 'All volunteer frequency boxes must be filled.';
      } else {
        this.volunteerFrequencyValidationMessage = '';
      }
      return allFilled;
    }
    return false;
  }
  checkBufferFields(): boolean {
    const bufferControl = this.studyForm.get('buffer') as FormArray;
    if (bufferControl) {
      const allFilled = bufferControl.controls.every(control => 
        (typeof control.value == 'string' && control.value.trim() !== '') || (typeof control.value != 'string')
      );
      if (!allFilled) {
        this.bufferValidationMessage = 'All buffer boxes must be filled.';
      } else {
        this.bufferValidationMessage = '';
      }
      return allFilled;
    }
    return false;
  }
  checkStudyNameAndCode(): boolean {
    const studyNameControl = this.studyForm.get('studyName');
    const studyCodeControl = this.studyForm.get('studyCode');
    const cdaDocumentLinkControl = this.studyForm.get('cdaDocumentLink');
    const selectedCrcsControl = this.studyForm.get('selectedCrcs');
    const studyDurationControl = this.studyForm.get('studyDuration');
    const noOfDaysControl = this.studyForm.get('noOfDays');
    const bufferControl = this.studyForm.get('buffer');
  
    // Reset validation messages initially
    this.validationMessage1 = '';
    this.validationMessage2 = '';
    this.validationMessage3 = '';
    this.validationMessage4 = '';
    this.validationMessage5 = '';
    this.validationMessage6 = '';
    this.validationMessage7 = '';
  
    let isValid = true; // To track if all fields are valid
  
    // Validate studyName
    const studyName = (studyNameControl?.value?.trim()) || '';
    if (!studyName) {
      this.validationMessage1 = 'Study name is required.';
      isValid = false;
    }
  
    // Validate studyCode
    const studyCode = (studyCodeControl?.value?.trim()) || '';
    if (!studyCode) {
      this.validationMessage2 = 'Study code is required.';
      isValid = false;
    }
  
    // Validate CDA Document Link
    const cdaDocumentLink = (cdaDocumentLinkControl?.value?.trim()) || '';
    if (!cdaDocumentLink) {
      this.validationMessage3 = 'CDA Document Link is required.';
      isValid = false;
    }
  
    // Validate selected CRCs (array)
    const selectedCrcs = selectedCrcsControl?.value || [];
    if (selectedCrcs.length === 0) {
      this.validationMessage4 = 'At least one CRC must be selected.';
      isValid = false;
    }
  
    // Validate Study Duration
    const studyDuration = studyDurationControl?.value || '';
    if (!studyDuration) {
      this.validationMessage5 = 'Study duration is required.';
      isValid = false;
    }
  
    // Validate Number of Days
    const noOfDays = noOfDaysControl?.value || '';
    if (!noOfDays) {
      this.validationMessage6 = 'Number of days is required.';
      isValid = false;
    }
  
    // Validate Buffer (dropdown or number)
    const buffer = bufferControl?.value || '';
    if (!buffer) {
      this.validationMessage7 = 'Buffer is required.';
      isValid = false;
    }
  
    return isValid; // Return true if all fields are valid, otherwise false
  }
  
  checkVolunteerFrequencySum(): boolean {
    const volunteerFrequenciesControl = this.studyForm.get('volunteerFrequencies') as FormArray;
  
    if (volunteerFrequenciesControl) {
      const maxSum = this.getMaxDays(); // Use getMaxDays() to get the maximum allowable sum based on duration
  
      const sum = volunteerFrequenciesControl.controls
        .map(control => parseFloat(control.value) || 0)
        .reduce((acc, value) => acc + value, 0);
  
      // Compare the sum with the calculated maximum
      if (sum > maxSum) {
        this.volunteerFrequencyValidationMessage = `Total volunteer frequency cannot exceed ${maxSum} days for the given duration.`;
        return false;
      } else {
        this.volunteerFrequencyValidationMessage = '';
        return true;
      }
    }
    return false;
  }
  
  openStudy(study: any) {

    // Get study_crc_id from assigned users if available
    let studyCrcId = null;
    if (study.assigned_users && study.assigned_users.length > 0) {
      studyCrcId = study.assigned_users[0].study_crc_id;
    }

    var state = {
      study_name : study.study_name || null,
      study_id : study.id || null,
      study_crc_id : studyCrcId, // This is the correct ID for the backend API
      study_status : study.status || null,
      site_name : study.site_list[0].site_name || null,
      template_name : study.template_list[0].name || null,
      template_id : null
    }

    this.apiService.getTemplateId(study.template_list[0].name).subscribe(
      response => {
        // console.log(response);
        state.template_id = response.template_id;
        this.router.navigate(['/study-template', { data: JSON.stringify(state) }]);
      },
      error => {
        console.error('Error fetching template ID:', error);
      }
    )
    // Navigate to study-template with template ID and study information
    // const templateName = this.getTemplateName(study);
    // const templateId = study.template_id || (study.template_list && study.template_list.length > 0 ? study.template_list[0].id : null);
    

    // if (templateId) {
    //   this.router.navigate(['/study-template', templateId], {
    //     queryParams: {
    //       study_id: study.id,
    //       template_name: templateName,
    //       study_name: study.study_name
    //     }
    //   });
    // } else {
    //   console.error('No template ID found for study:', study);
    //   alert('No template found for this study');
    // }
  }

  viewStudy(index: number) {
    this.router.navigate(['/study-crc-view/' + index]);
  }

onBufferInput(index: number) {
  const bufferControl = this.studyForm.get('buffer') as FormArray;
  const bufferValue = bufferControl.at(index).value;

  if (!this.isValidBufferValue(bufferValue)) {
      bufferControl.at(index).setErrors({ invalidBuffer: true });
  } else {
      bufferControl.at(index).setErrors(null);
  }
}

isValidBufferValue(value: any): boolean {
  return typeof value === 'number' && value >= 0 && value <= 100;
}



validateBufferValue(control: FormControl): ValidationErrors | null {
  const bufferValue = control.value;
  if (typeof bufferValue !== 'number' || bufferValue < 0 || bufferValue > 100) {
    return { invalidBuffer: true }; 
  }
  return null;
}


 /* closeModal(): void {
    const modalElement = document.getElementById('createStudyModal');
    if (modalElement) {
      const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    }
    this.editStudyData = {};
    this.generatedDayInputs = [];
    this.studyForm.reset();
    const volunteerFrequenciesControl = this.studyForm.get('volunteerFrequencies') as FormArray;
    volunteerFrequenciesControl.clear();
    this.studyForm.enable();
  }*/
    closeModal(): void {
      this.showCreateStudyModal = false;
      this.editStudyData = {};
      this.generatedDayInputs = [];
      this.studyForm.reset();
      // auto reload was not working properly so commented it
      // const volunteerFrequenciesControl = this.studyForm.get('volunteerFrequencies') as FormArray;
      // volunteerFrequenciesControl.clear();
      this.studyForm.enable();
    }


  editStudy(studyData: any): void {
    this.studyForm.patchValue({
      studyName: studyData.study_name,
      studyCode: studyData.code,
    });
  }

  disableStudy(id: number, isActive: boolean): void {
  
    if (!id) {
      console.error('Study ID is undefined');
      return;
    }
  
    const payload = { is_active: isActive ? 1 : 0 };
    this.apiService.post(`api/deactivateStudy/${id}`, payload).subscribe(
      (response) => {
        this.loadUsers(this.currentPage); // Refresh the study list
      },
      (error) => {
        console.error('Error updating study status:', error);
        window.alert('Failed to update study status.');
      }
    );
  }
  /*getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }*/
  onCreate(): void {
    // Ensure `this.document.cookie` is accessible
 /* const cookies = this.document.cookie || '';

  // Find the 'user_data' cookie and decode it
  const cookieString = cookies.split('; ').find(row => row.startsWith('userData=')) || '';
  if (!cookieString) {
    console.error('user_data cookie not found.');
    return;
  }
  try {
    // Decode and parse the cookie
    const decodedValue = decodeURIComponent(cookieString.split('=')[1]);
    const parsedCookies = JSON.parse(decodedValue);

    // Extract user details
    const { id, first_name, last_name } = parsedCookies;

    if (!id || !first_name || !last_name) {
      console.error('Missing required user details in cookie:', parsedCookies);
      return;
    }*/
  
    const studyData = {
      name: this.studyForm.get('studyName')?.value,
      code: this.studyForm.get('studyCode')?.value,
      template_id: this.studyForm.get('selectedTemplate')?.value?.item_id,
      site_ids: this.studyForm.get('selectedSiteLocations')?.value?.map((site: any) => site.item_id) || [],
      status: "Started",
      created_by: this.id
  };

  // Note: CRC assignments are now handled separately and not included in study updates



let isSuccess = false;
if (this.isEditMode) {
  this.apiService.post(`api/updateStudy/${this.editStudyData.id}`, studyData).subscribe(
    response => {
      isSuccess = true;
      window.alert(response.message);
      this.closeCreateStudyModal();
      // Reload the study list automatically instead of full page reload
      this.loadUsers(this.currentPage);
    },
    error => {
      console.error('Error Creating Study', error);
      
      // Show alert with error message from response for 400 status only
      if (error.status === 400) {
        let errorMessage = 'An error occurred while updating the study. Please try again.';
        if (error.error) {
          if (error.error.error) {
            errorMessage = error.error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          }
        }
        window.alert(errorMessage);
      } else {
        window.alert('An error occurred while updating the study. Please try again.');
      }
    }
  );
} else {
  this.apiService.post('api/createStudy', studyData).subscribe(
    response => {
      if (response && response.id) {
        window.alert('Created new study successfully');
        this.closeCreateStudyModal();
        // Reload the study list automatically instead of full page reload
        this.loadUsers(this.currentPage);
      } else {
        console.error('Unexpected API response:', response);
        window.alert(response.message || 'Unexpected error occurred');
      }
    },
    error => {
      console.error('Error Creating Study:', error);
      
      // Show alert with error message from response for 400 status only
      if (error.status === 400) {
        let errorMessage = 'An error occurred while creating the study. Please try again.';
        if (error.error) {
          if (error.error.error) {
            errorMessage = error.error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          }
        }
        window.alert(errorMessage);
      } else {
        // Extract the error message for other status codes
        let errorMessage = error.error?.error || '';
        // Evaluate the error message
        if (errorMessage.includes('Study with code')) {
          window.alert('Study code already exists. Please enter a new code.'); // Duplicate code error
        } 
        else if(errorMessage.includes('Study with name')) {
          window.alert('Study name already exists. Please enter a new name.'); // Duplicate name error
        } else {
          window.alert('An error occurred while creating the study. Please try again.'); // Fallback for unexpected errors
        }
      }
    }
  );
}
console.log(studyData);
}

// Method to get template name for display in table
getTemplateName(user: any): string {
  // First try to get template name from the new direct field
  if (user.template_name) {
    return user.template_name;
  }
  
  // Fallback to template_list array
  if (user.template_list && user.template_list.length > 0) {
    return user.template_list[0].name || 'Unknown Template';
  }
  
  return 'No Template';
}

// Custom dropdown methods for site location
toggleSiteLocationDropdown(): void {
  this.showSiteLocationDropdown = !this.showSiteLocationDropdown;
  if (this.showSiteLocationDropdown) {
    this.siteLocationSearchTerm = '';
    this.filteredSiteLocations = [...this.siteLocations];
  }
}

closeSiteLocationDropdown(): void {
  if (this.showSiteLocationDropdown) {
    this.showSiteLocationDropdown = false;
  }
}

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  // Only handle clicks when modal is open and dropdown is visible
  if (this.showCreateStudyModal && this.showSiteLocationDropdown) {
    const target = event.target as HTMLElement;
    // Check if click is inside the site location dropdown container
    const isInsideDropdownContainer = target.closest('.site-location-dropdown-container');
    
    // If click is outside the dropdown container, close the dropdown
    if (!isInsideDropdownContainer) {
      this.closeSiteLocationDropdown();
    }
  }
}

filterSiteLocations(): void {
  if (!this.siteLocationSearchTerm.trim()) {
    this.filteredSiteLocations = [...this.siteLocations];
  } else {
    this.filteredSiteLocations = this.siteLocations.filter((site: any) =>
      site.item_text.toLowerCase().includes(this.siteLocationSearchTerm.toLowerCase())
    );
  }
}

isSiteLocationSelected(site: any): boolean {
  const selectedSites = this.studyForm.get('selectedSiteLocations')?.value || [];
  return selectedSites.some((selected: any) => selected.item_id === site.item_id);
}

selectSiteLocation(site: any): void {
  const currentSelection = this.studyForm.get('selectedSiteLocations')?.value || [];
  const isSelected = this.isSiteLocationSelected(site);
  
  if (isSelected) {
    // Remove from selection
    const updatedSelection = currentSelection.filter((selected: any) => selected.item_id !== site.item_id);
    this.studyForm.get('selectedSiteLocations')?.setValue(updatedSelection);
  } else {
    // Add to selection
    const newSelection = [...currentSelection, site];
    this.studyForm.get('selectedSiteLocations')?.setValue(newSelection);
  }
}

  removeSelectedSiteLocation(site: any): void {
    const currentSelection = this.studyForm.get('selectedSiteLocations')?.value || [];
    const updatedSelection = currentSelection.filter((selected: any) => selected.item_id !== site.item_id);
    this.studyForm.get('selectedSiteLocations')?.setValue(updatedSelection);
  }

  private populateSitesInForm(studyData: any): void {
    // Now try to find all sites from the study data
    let foundSites: { item_id: string | number; item_text: string }[] = [];
    
    if (studyData.site_list && studyData.site_list.length > 0) {
      // Process all sites in the site_list
      for (const siteItem of studyData.site_list) {
        let foundSite: { item_id: string | number; item_text: string } | null = null;
        
        // Try to find by site name if available
        if (siteItem.site_name) {
          foundSite = this.siteLocations.find(site => site.item_text === siteItem.site_name) || null;
        }
        
        // If not found by name, try to find by site ID
        if (!foundSite) {
          const siteId = siteItem.site_id || siteItem.id;
          if (siteId) {
            // Try both string and number comparison
            foundSite = this.siteLocations.find(site => 
              site.item_id == siteId || 
              site.item_id === siteId || 
              site.item_id === String(siteId) ||
              site.item_id === Number(siteId)
            ) || null;
          }
        }
        
        // If still not found, try to create a site object from the data
        if (!foundSite && siteItem.site_name) {
          foundSite = {
            item_id: siteItem.site_id || siteItem.id,
            item_text: siteItem.site_name
          };
        }
        
        if (foundSite) {
          foundSites.push(foundSite);
        }
      }
    } else if (studyData.site_name) {
      // Fallback to single site_name field
      const foundSite = this.siteLocations.find(site => site.item_text === studyData.site_name) || null;
      if (foundSite) {
        foundSites.push(foundSite);
      }
    }
    
    if (foundSites.length > 0) {
      // Update the form with all found sites
      this.studyForm.patchValue({
        selectedSiteLocations: foundSites
      });
    }
  }
}

